import React from 'react';
import styles from '../Form.module.scss';

type FormFieldsetPropsType = {
  legend?: string;
  children: React.ReactChild;
};

const FormFieldset = (props: FormFieldsetPropsType) => {
  return (
    <div role="group" className={styles.formFieldsetWrapper}>
      {props.legend && <legend>{props.legend}</legend>}

      {props.children}
    </div>
  );
};

export default FormFieldset;
